var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDelivered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10341",
    "data-name": "Group 10341",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#313d85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10337",
    "data-name": "Group 10337",
    transform: "translate(-3.692 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M19092.971,22699.088a1.115,1.115,0,0,1-1.113-1.119v-2.232h-13.393v2.232a1.12,1.12,0,0,1-1.119,1.119h-1.111a1.12,1.12,0,0,1-1.117-1.119v-2.3a1.252,1.252,0,0,1,.043-.217,2.222,2.222,0,0,1-1.156-1.945v-5.58a2.227,2.227,0,0,1,1.365-2.053l1.527-4.584a3.349,3.349,0,0,1,3.176-2.287h10.172a3.35,3.35,0,0,1,3.178,2.287l1.525,4.584a2.227,2.227,0,0,1,1.373,2.053v5.58a2.232,2.232,0,0,1-1.162,1.945.974.974,0,0,1,.045.217v2.3a1.117,1.117,0,0,1-1.113,1.119Zm-16.736-5.582h17.855v-5.58h-17.855Zm2.777-11.51-1.232,3.7h14.76l-1.234-3.7a1.114,1.114,0,0,0-1.061-.764h-10.172A1.117,1.117,0,0,0,19079.012,22682Zm10.609,8.719a1.675,1.675,0,1,1,1.68,1.678A1.674,1.674,0,0,1,19089.621,22690.715Zm-12.275,0a1.675,1.675,0,1,1,1.68,1.678A1.674,1.674,0,0,1,19077.346,22690.715Z",
    transform: "translate(-19025.125 -22654.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-check",
    d: "M8.887,13.625,6.373,11.111l-1.08,1.08,3.594,3.594L16.3,8.373l-1.08-1.08Z",
    transform: "translate(66.207 28.522)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelivered);
export default __webpack_public_path__ + "static/media/Order Delivered.e04325ee8c239f634f7f1bd86f0d35f2.svg";
export { ForwardRef as ReactComponent };